export function formatMailAddress(mailAddress: string) {
  const splitMailAddress = mailAddress.split('@');
  return {
    emailAccount: splitMailAddress[0],
    emailDomain: splitMailAddress[1],
  };
}
